import { render, staticRenderFns } from "./WorkOrdersListPage.vue?vue&type=template&id=50edd163&scoped=true"
import script from "./WorkOrdersListPage.vue?vue&type=script&lang=js"
export * from "./WorkOrdersListPage.vue?vue&type=script&lang=js"
import style0 from "./WorkOrdersListPage.vue?vue&type=style&index=0&id=50edd163&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50edd163",
  null
  
)

export default component.exports